import CASL from '@/utils/constants/casl'

export default {
  path: 'app-terms-condition',
  children: [
    {
      path: '',
      name: 'app-terms-condition.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.MOBILE_APP_SETUP
      },
      component: () => import('./list/AppTermsConditionPage.vue')
    }
  ]
}
